import { useEffect } from 'react'

import { useAppDispatch } from 'src/Hooks/redux'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { rtkApi } from 'src/Services/rtkApi'
import {
  SPOTIFY_RECONNECT_DISPLAY_NAME_PARAM,
  SPOTIFY_RECONNECT_ERROR_PARAM,
  SPOTIFY_RECONNECT_FLAG,
  SPOTIFY_RECONNECT_SUCCEEDED_PARAM,
  SPOTIFY_WRONG_ACCOUNT_ERROR,
} from 'src/Utils/spotifyReconnect'
import { getPendingSpotifyReview } from 'src/Utils/pendingSpotifyReview'

interface UseSpotifyReconnectResult {
  isWrongAccount: boolean
  attemptedSpotifyDisplayName: string
}

export const useSpotifyReconnectResult = (): UseSpotifyReconnectResult => {
  const dispatch = useAppDispatch()
  const { search, setSearch } = useCustomSearchParams()

  const isSpotifyReconnect = search.get(SPOTIFY_RECONNECT_FLAG) === '1'
  const succeeded = isSpotifyReconnect
    ? search.get(SPOTIFY_RECONNECT_SUCCEEDED_PARAM)
    : null
  const error = search.get(SPOTIFY_RECONNECT_ERROR_PARAM)

  const isWrongAccount =
    isSpotifyReconnect &&
    succeeded === 'false' &&
    error === SPOTIFY_WRONG_ACCOUNT_ERROR

  useEffect(() => {
    if (succeeded === null || isWrongAccount) {
      return
    }

    if (succeeded === 'true') {
      dispatch(rtkApi.util.invalidateTags(['CuratorSpotifyInfo']))
    }

    if (getPendingSpotifyReview() !== null) {
      return
    }

    setSearch(
      {
        [SPOTIFY_RECONNECT_SUCCEEDED_PARAM]: null,
        [SPOTIFY_RECONNECT_ERROR_PARAM]: null,
        [SPOTIFY_RECONNECT_DISPLAY_NAME_PARAM]: null,
        [SPOTIFY_RECONNECT_FLAG]: null,
      },
      { replace: true },
    )
  }, [succeeded, isWrongAccount, dispatch, setSearch])

  return {
    isWrongAccount,
    attemptedSpotifyDisplayName:
      search.get(SPOTIFY_RECONNECT_DISPLAY_NAME_PARAM) ?? '',
  }
}
